module.exports = __webpack_public_path__ + "static/media/mainimg-06.ffc28780.png";